import {
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  List,
  ListItem,
  ListItemText,
  Box,
} from "@mui/material";
import { useState } from "react";

function PassPhrase(props) {
  const [passphrase, setPassphrase] = useState("");

  function onClickButton() {
    props.setPassPhrase(passphrase);
  }

  return (
    <Card sx={{ mb: 2 }}>
      <CardContent>
        <Typography variant="h5" component="h2" gutterBottom>
          4. Enhance Security with Passphrase (Optional)
        </Typography>
        <Box sx={{ display: "flex", mb: 2 }}>
          <TextField
            id="passphrase"
            label="Enter your custom passphrase"
            variant="outlined"
            fullWidth
            value={passphrase}
            onChange={(e) => setPassphrase(e.target.value)}
          />
          <Button
            variant="contained"
            onClick={onClickButton}
            sx={{ ml: 1, whiteSpace: "nowrap" }}
          >
            Apply
          </Button>
        </Box>
        <List dense>
          <ListItem>
            <ListItemText
              primary="Adding a passphrase will generate a different private key from the mnemonic."
              secondary="While there's no limit to the passphrase length, we recommend keeping it under 100 characters for compatibility with other wallets."
            />
          </ListItem>
        </List>
      </CardContent>
    </Card>
  );
}

export default PassPhrase;
